import styled from 'styled-components';
import { Form } from 'antd';

export const StyledForm = styled(Form)`
  .ant-form-item {
    .ant-form-item-label {
      text-align: start;
      > label {
        display: inline !important;
        font-size: 14px;
        font-weight: 500;
        min-height: 40px;
        height: fit-content;
        color: rgba(92, 101, 110, 1);
        white-space: initial;
        &::after {
          content: '';
          display: none;
        }
        &::before {
          content: '';
          display: none;
        }
        &.ant-form-item-required::after {
          display: inline !important;
          margin-inline-start: 4px;
          color: #ff4d4f;
          font-size: 16px;
          font-family: Vinila Variable;
          line-height: 1;
          content: '*';
          visibility: unset !important;
        }
      }
    }
    .ant-form-item-control-input {
      height: 100%;
    }
  }
`;
